import { createClient } from '@supabase/supabase-js';
import type { Database } from '../../types/database';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Please check .env file.');
}

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
  db: {
    schema: 'public',
  },
  global: {
    headers: {
      'x-client-info': 'mal-ops-dashboard',
    },
  },
});

// Helper to get current staff user
export const getCurrentStaffUser = async () => {
  const { data: { user } } = await supabase.auth.getUser();
  
  if (!user) return null;

  const { data: staffUser } = await supabase
    .from('staff_users')
    .select('*')
    .eq('auth_user_id', user.id)
    .single() as any;

  return staffUser;
};

// Helper to check if user is authenticated
export const isAuthenticated = async (): Promise<boolean> => {
  const { data: { session } } = await supabase.auth.getSession();
  return !!session;
};

// Helper to check staff status
export const isStaffActive = async (): Promise<boolean> => {
  const staffUser = await getCurrentStaffUser();
  return (staffUser as any)?.status === 'active';
};

